import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import React from 'react';
import { useAuthStore } from './stores/authStore';
import { authApi } from './services/authService';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProjectList from './pages/project/ProjectList';
import ProjectDetail from './pages/project/ProjectDetail';
import KnowledgeBase from './pages/knowledge/KnowledgeBase';
import ArtifactsPage from './pages/artifacts/ArtifactsPage';
import RequirementPage from './pages/requirement/RequirementPage';
import PrototypePage from './pages/prototype/PrototypePage';
import ApiDesignPage from './pages/api/ApiDesignPage';
import ArchitecturePage from './pages/architecture/ArchitecturePage';
import DeploymentPage from './pages/deployment/DeploymentPage';
import TestingPage from './pages/testing/TestingPage';
import DevWorkspace from './pages/dev-workspace';
import TeamCollabPage from './pages/team-collab';
import DigitalOfficePage from './pages/digital-office';
import Settings from './pages/Settings';
import HistoryPage from './pages/history/HistoryPage';
import SkillMarketPage from './pages/skill-market';
import SmartReqPage from './pages/smart-requirement';
import AiDemandCenterPage from './pages/ai-demand-center';
import TechComponentsPage from './pages/tech-components';
import PptDesignerPage from './pages/ppt-designer';
import DesignCreatorPage from './pages/design-creator/DesignCreatorPage';
import AgentRuntimePage from './pages/AgentRuntime';
import AgentDeveloperCenterPage from './pages/agent-developer-center';
import WorkIntelPage from './pages/work-intel';
import IdeaCenterPage from './pages/idea-center';
import AICommandOffice from './pages/ai-command-office';
import FreeWhiteboard from './pages/free-whiteboard';

function App() {
  const { isAuthenticated, token, updateUser } = useAuthStore();

  // 启动时刷新用户信息（确保roles等字段是最新的）
  React.useEffect(() => {
    if (isAuthenticated && token) {
      authApi.getProfile().then(user => {
        updateUser(user as any);
      }).catch(() => {});
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (!isAuthenticated) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* AI 指挥办公室 — 独立全屏布局，不挂 MainLayout */}
        <Route path="/ai-command-office" element={<AICommandOffice />} />
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="projects" element={<ProjectList />} />
          <Route path="projects/:id/*" element={<ProjectDetail />} />
          <Route path="knowledge" element={<KnowledgeBase />} />
          <Route path="artifacts/:projectId?" element={<ArtifactsPage />} />
          <Route path="requirement/:projectId" element={<RequirementPage />} />
          <Route path="prototype/:projectId" element={<PrototypePage />} />
          <Route path="api/:projectId" element={<ApiDesignPage />} />
          <Route path="architecture/:projectId" element={<ArchitecturePage />} />
          <Route path="deployment/:projectId" element={<DeploymentPage />} />
          <Route path="testing/:projectId" element={<TestingPage />} />
          <Route path="dev-workspace" element={<DevWorkspace />} />
          <Route path="team-collab" element={<Navigate to="/workroom" replace />} />
          <Route path="workroom" element={<TeamCollabPage />} />
          <Route path="digital-office" element={<DigitalOfficePage />} />
          <Route path="settings" element={<Settings />} />
          <Route path="history" element={<HistoryPage />} />
          <Route path="skill-market" element={<SkillMarketPage />} />
          <Route path="smart-requirement" element={<SmartReqPage />} />
          <Route path="ai-demand-center" element={<AiDemandCenterPage />} />
          <Route path="ppt-designer" element={<PptDesignerPage />} />
          <Route path="ppt-designer/:projectId" element={<PptDesignerPage />} />
          <Route path="design-creator" element={<DesignCreatorPage />} />
          <Route path="tech-components" element={<TechComponentsPage />} />
          <Route path="agent-runtime" element={<AgentRuntimePage />} />
          <Route path="agent-developer-center" element={<AgentDeveloperCenterPage />} />
          <Route path="work-intel" element={<WorkIntelPage />} />
          <Route path="idea-center" element={<IdeaCenterPage />} />
          <Route path="free-whiteboard" element={<FreeWhiteboard />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
